
const inlineConfig = {
  "alternativesSlugs": [
    "honeybook",
    "dubsado",
    "bonsai",
    "gohighlevel",
    "quo-openphone",
    "freshbooks",
    "quickbooks",
    "moxie",
    "17hats",
    "plutio",
    "suitedash",
    "zoho-one",
    "trello",
    "productive",
    "accelo",
    "scoro",
    "hubspot"
  ],
  "nuxt": {}
}

/** client **/
import { _replaceAppConfig } from '#app/config'

// Vite - webpack is handled directly in #app/config
if (import.meta.dev && !import.meta.nitro && import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    if (newModule) {
      _replaceAppConfig(newModule.default)
    }
  })
}
/** client-end **/



export default inlineConfig
